import { makeStyles } from 'tss-react/mui';

const useStylesQrConfirmation = makeStyles()((theme) => {
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            minHeight: '100%',
            padding: '24px',
            backgroundColor: '#f1f1f1',
            textAlign: 'center',
            boxSizing: 'border-box',
        },
        card: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '24px',
            maxWidth: '760px',
            padding: '48px 32px',
        },
        icon: {
            width: '128px',
            height: '128px',
            borderRadius: '28px',
            boxShadow: '0 12px 32px rgba(0, 0, 0, 0.18)',
            objectFit: 'cover',
        },
        title: {
            margin: 0,
            fontWeight: 600,
        },
        description: {
            margin: 0,
            maxWidth: '520px',
            color: theme.palette.text?.secondary || '#5f6368',
            lineHeight: 1.5,
        },
        storeButtons: {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: '20px',
            marginTop: '8px',
        },
        storeButton: {
            minWidth: '224px',
            height: '62px',
            padding: '8px 18px',
            justifyContent: 'flex-start',
            gap: '13px',
            color: '#fff',
            backgroundColor: '#000',
            border: '2px solid #9a9a9a',
            borderRadius: '10px',
            boxShadow: '0 1px 0 rgba(255, 255, 255, 0.24) inset',
            textTransform: 'none',
            '&:hover': {
                backgroundColor: '#111',
                borderColor: '#b7b7b7',
            },
            '& .MuiButton-startIcon': {
                margin: 0,
            },
            [theme.breakpoints.down('sm')]: {
                width: '100%',
                maxWidth: '260px',
                minWidth: 0,
            },
        },
        appleIcon: {
            width: '38px',
            height: '38px',
            flexShrink: 0,
        },
        googlePlayIcon: {
            width: '36px',
            height: '36px',
            flexShrink: 0,
        },
        storeText: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            lineHeight: 1,
            color: '#fff',
        },
        storeEyebrow: {
            fontSize: '13px',
            fontWeight: 600,
            lineHeight: 1.1,
            letterSpacing: 0,
            whiteSpace: 'nowrap',
        },
        storeLabel: {
            marginTop: '3px',
            fontSize: '25px',
            fontWeight: 600,
            lineHeight: 1,
            letterSpacing: 0,
            whiteSpace: 'nowrap',
        },
    };
});

export default useStylesQrConfirmation;
